/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import IntlMessageComponent from 'components/formatters/intlMessage';
import IconCancel from 'components/icons/cancel';

type MessageDialogComponentProps = {
  open: boolean;
  text: string;
  title?: string;
  maxWidth?: string;
  disableBackdropClick?: boolean;
  disableEscapeKeyDown?: boolean;
  onClose: () => void;
}

export default function MessageDialogComponent(props: MessageDialogComponentProps) {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      fullWidth
      maxWidth={props.maxWidth || "sm"}
      disableBackdropClick={props.disableBackdropClick}
      disableEscapeKeyDown={props.disableEscapeKeyDown}
    >
      <DialogContent>
        <Box
          position="relative"
          minHeight={160}
          display="flex"
          alignItems="center"
          justifyContent="center"
          px={4}
          py={4}
        >
          <IconButton
            aria-label="close"
            onClick={props.onClose}
            style={{ position: 'absolute', top: 8, right: 8 }}
          >
            <IconCancel fontSize="small" />
          </IconButton>

          <Box textAlign="center">
            {props.title &&
              <Box mb={2}>
                <Typography variant="h6">
                  <IntlMessageComponent id={props.title} />
                </Typography>
              </Box>
            }

            <Typography variant="body1">
              <IntlMessageComponent id={props.text} />
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}